<app-features-container
  header="{{ '+INSTALLATIONS.INSTALLATION.BUFFER_TANK.TITLE' | translate }}"
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  [overlayType]="availableOverlays.BufferTank"
>
  <!-- heating.buffer.operating.modes.active -->
  <app-feature-tile
    *ngIf="bufferTankOperatingMode$ | async | ready as feature"
    feature
    data-at-buffer-tank-active-mode
    label="{{ '+INSTALLATIONS.INSTALLATION.BUFFER_TANK_PROPERTIES.ACTIVE_MODE' | translate }}"
    value="{{ feature | value2: featurePropertyKey.value | translateBufferTankOperatingMode }}"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>

  <app-feature-tile
    *ngIf="bufferTankTemperatureMain$ | async | ready as feature"
    feature
    data-at-buffer-tank-temperature-main
    label="{{
      '+INSTALLATIONS.INSTALLATION.BUFFER_TANK_PROPERTIES.BUFFER_TEMPERATURE' | translate
    }}"
    value="{{ feature | value2: featurePropertyKey.value | translateBufferTankOperatingMode }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
  ></app-feature-tile>
</app-features-container>
